import { getDebugNode } from '@angular/core';

/**
 * Resolve a component instance from a host DOM element using Angular's public
 * `getDebugNode` API (works in production — does not rely on the `ng` global,
 * which is only published under `ngDevMode`).
 */
export function resolveComponentFromHostElement<T>(host: Element): T | null {
  const instance = getDebugNode(host)?.componentInstance as T | null | undefined;
  return instance ?? null;
}
